import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function GoogleCallback() {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const err = params.get("error");
    const saved = sessionStorage.getItem("xurray_g_state");
    sessionStorage.removeItem("xurray_g_state");

    (async () => {
      if (err || !code) {
        toast.error("Google sign-in was cancelled.");
        navigate("/login", { replace: true });
        return;
      }
      if (!state || state !== saved) {
        toast.error("Google sign-in failed (security check). Please try again.");
        navigate("/login", { replace: true });
        return;
      }
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = window.location.origin + "/auth/google";
        const user = await googleExchange(code, redirectUri);
        toast.success(`Welcome, ${user.name}!`);
        const pendingSeller = localStorage.getItem("xurray_pending_role") === "seller";
        if (pendingSeller) localStorage.removeItem("xurray_pending_role");
        let dest = user.role === "admin" ? "/admin" : user.role === "seller" ? "/seller" : "/";
        if (pendingSeller && user.role !== "admin" && !(user.role === "seller" && user.seller_status === "approved")) dest = "/sell";
        navigate(dest, { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Google sign-in failed.");
        navigate("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" data-testid="google-callback">
      <Loader2 className="w-7 h-7 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Signing you in with Google…</p>
    </div>
  );
}
